import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_SAP_AI_PROMPT = defineFcm('starter_sap_ai_prompt')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				legacyAPI: { type: 'boolean', optional: true },
				systemPrompt: { type: 'string' },
				prompt: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							replacer: { type: 'string' },
							filter: { type: 'string' },
							text: { type: 'string' },
						},
					},
				},
				options: {
					type: 'object',
					optional: true,
					shape: {
						model: { type: 'string', optional: true },
						temperature: { type: 'number', optional: true },
						frequency_penalty: { type: 'number', optional: true },
					},
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		systemPrompt: '',
		prompt: [],
		legacyAPI: undefined,
		options: undefined,
	})
	.toConfig();
